import React from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Message } from 'primereact/message';
import { extractResponseData, SmartHeader, NoRecordsCard, SmartField } from './_SmartFieldRenderer';

const DigilockerStatusOutputComponent = ({ reportData, hideCredits, isSharedView }) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg } = extractResponseData(reportData);

    if (!reportData) return <NoRecordsCard subtitle="No data available" />;

    if (!responseData) {
        return (
            <Card className="text-center">
                <i className="pi pi-times-circle text-5xl text-red-500 block mb-3" aria-hidden="true" />
                <h3 className="text-lg font-semibold text-900 m-0 mb-2">Status Check Failed</h3>
                {errorMsg && <p className="text-600 text-sm m-0">{errorMsg}</p>}
            </Card>
        );
    }

    const completed = responseData.completed === true || responseData.completed === 'true' || responseData.status === 'completed';
    const clientId = responseData.client_id;
    const docsDownloaded = responseData.docs_downloaded ?? responseData.documents_downloaded;
    const createdAt = responseData.created_at || responseData.timestamp;
    const aadhaarLinked = responseData.aadhaar_linked;
    const mobileNumber = responseData.mobile_number;
    const email = responseData.email;
    const name = responseData.name || responseData.full_name;

    return (
        <div>
            <SmartHeader title="Digilocker Authentication Status" icon="pi-info-circle" remainingBalance={remainingBalance} shouldHideCredits={shouldHideCredits} />

            <Card>
                {completed ? (
                    <Message
                        severity="success"
                        text="Authentication completed. The user has successfully completed Digilocker authentication. You can now proceed to List Documents."
                        className="w-full mb-3"
                    />
                ) : (
                    <Message
                        severity="warn"
                        text="Authentication pending. The user has not completed Digilocker authentication yet. Please open the URL from the Initialize step and complete Aadhaar OTP login."
                        className="w-full mb-3"
                    />
                )}

                <div className="grid">
                    {clientId && <SmartField name="client_id" value={clientId} highlight />}
                    <div className="col-12 sm:col-6 lg:col-4 flex flex-column gap-1">
                        <span className="text-500 text-xs font-medium">Completed</span>
                        <span><Tag value={completed ? 'Yes' : 'No'} severity={completed ? 'success' : 'warning'} /></span>
                    </div>
                    {aadhaarLinked !== undefined && (
                        <div className="col-12 sm:col-6 lg:col-4 flex flex-column gap-1">
                            <span className="text-500 text-xs font-medium">Aadhaar Linked</span>
                            <span><Tag value={aadhaarLinked ? 'Yes' : 'No'} severity={aadhaarLinked ? 'success' : 'danger'} /></span>
                        </div>
                    )}
                    {docsDownloaded !== undefined && <SmartField name="documents_available" value={String(docsDownloaded)} />}
                    {name && <SmartField name="name" value={name} />}
                    {mobileNumber && <SmartField name="mobile" value={mobileNumber} />}
                    {email && <SmartField name="email" value={email} />}
                    {createdAt && <SmartField name="session_created" value={createdAt} />}
                </div>
            </Card>
        </div>
    );
};

export default DigilockerStatusOutputComponent;
